export default __webpack_public_path__ + "static/plumeria-5878cf69bfde76b409a0e069017cb3c4.png";